import moment from 'moment/moment';
import validator from 'validator';

function AddCompanyValidation(data) {
  const errors = {};

  if (validator.isEmpty(data.company_name.trim()))
    errors.company_name = 'Please enter the company name.';
  if (validator.isEmpty(data.company_email.trim()))
    errors.company_email = 'Please enter the email address.';
  else if (!validator.isEmail(data.company_email))
    errors.company_email = 'Please enter valid email address.';
  if (validator.isEmpty(data.company_address.trim()))
    errors.company_address = 'Please enter the company address.';
  if (validator.isEmpty(data.contact_person.trim()))
    errors.contact_person = 'Please enter the contact person.';
  if (data.other_admin_emails) {
    const tempArr = data.other_admin_emails?.split(',');
    for (const data of tempArr) {
      if (!validator.isEmail(data.trim())) {
        errors.other_admin_emails = 'Please enter valid email address.';
        break;
      }
    }
  }
  if (data.no_of_seat_bought <= 0) {
    errors.no_of_seat_bought = 'Please enter at least 1 seat.';
  }

  if (!data.b2bPlan) {
    errors.b2bplan = 'Please choose a valid plan.';
  }
  if (!data.plan) {
    errors.plan = 'Please choose a valid payment type.';
  }

  if (isNaN(data.seat_price) || data.seat_price <= 0 || data.seat_price > 10) {
    errors.seat_price = 'Please choose a valid seat price between 0.01 and 10.';
  }

  console.log(data.contract_end_date);
  if (!data.contract_start_date) {
    errors.contract_start_date = 'Contract start date cannot be null.';
  }
  if (!data.contract_end_date) {
    errors.contract_end_date = 'Contract end date cannot be null.';
  }

  const startDate = moment(data.contract_start_date);
  const endDate = moment(data.contract_end_date);

  if (endDate.diff(startDate, 'days', true) < 1) {
    errors.contract_end_date = 'Contract duration should be at least 1 day.';
  }
  if (!!data.is_child_company && (!data.parent_company || data.parent_company === '')) {
    errors.parent_company = 'Please select a parent company.';
  }
  if (!!data.is_child_company) {
    const externalCompanyId = (data.external_company_id || '').trim();
    if (validator.isEmpty(externalCompanyId)) {
      errors.external_company_id = 'Please enter external company ID.';
    } else if (!/^[a-z0-9_-]{1,64}$/.test(externalCompanyId)) {
      errors.external_company_id =
        'Company code must contain only lowercase letters, numbers, hyphen or underscore (max 64 characters).';
    }
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export default AddCompanyValidation;
